
import { defineComponent, PropType, ref } from "vue";
import { Insight } from "@/models/insight";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { Observation } from "@/store/reports/models";
import IButton from "@/components/buttons/IButton.vue";
import { useI18n } from "vue-i18n";
import { mapGetters } from "vuex";
import { RootGetters } from "@/store/getters";
import { filterBy } from '@progress/kendo-data-query';


export default defineComponent({
  name: "DropdownSelect",
  setup() {
    const {t} = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    const dropdownlist = ref()
    return { t, dropdownlist }
  },
  data() {
    return {
      selected: this.prefill,
      items: []
    };
  },
  computed: {
    ...mapGetters({
        activeCase: RootGetters.GET_ACTIVE_CASE,
        activeSlide: RootGetters.ACTIVE_SLIDE,
    }),
    translatedItems() {
      let options = this.insight.controller.options.slice();
      options = options.map((option) => {
        return this.t(`config.insight.slide.${this.activeCase.tissue}.${this.activeSlide.stain}.${this.insight.key}.controller.${option}`);
      });
      return options;
    },
  },
  mounted() {
    this.selected = this.prefill ? this.prefill : this.t('component.dropdown.placeholder');
    this.items = this.insight.controller.options.map((option: string) => {
      return this.t(`config.insight.slide.${this.activeCase.tissue}.${this.activeSlide.stain}.${this.insight.key}.controller.${option}`);
    })
  },
  props: {
    insight: {
      type: Object as PropType<Insight>,
    },
    prefill: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    observationChange(observation: Observation): boolean {
      return observation.key !== "" && observation.title !== "";
    },
  },
  methods: {
    handleChange() {
      let observation: Observation = {
        key: this.insight.key,
        title: this.t(`config.insight.slide.${this.activeCase.tissue}.${this.activeSlide.stain}.${this.insight.key}.title`),
        value: this.selected,
      };
      if (!this.items.includes(this.selected)) {
        observation.value = '';
      }
      this.$emit("observationChange", observation);
    },
    filterChange (event) {
      this.items = this.filterData(event.filter);
    },
    filterData(filter) {
        const data = this.translatedItems.slice();
        return filterBy(data, filter);
    },
  },
  components: {
    'dropdownlist': DropDownList,
    IButton,
  },
  watch: {
    prefill(newVal, oldVal) {
      this.selected = newVal ? newVal : this.t("component.dropdown.placeholder");
    },
  },
});
